var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.375,
    height: 12.778,
    viewBox: "0 0 14.375 12.778",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#7a7a7a;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.155,14.759V14.1a3.567,3.567,0,0,0,1.6-2.968c0-1.985,0-3.594-2.4-3.594s-2.4,1.609-2.4,3.594a3.567,3.567,0,0,0,1.6,2.968v.659c-2.709.221-4.792,1.553-4.792,3.162h11.18c0-1.609-2.083-2.94-4.792-3.162Zm-5.5.308a7.587,7.587,0,0,1,2.493-1,4.505,4.505,0,0,1-.505-.736,4.573,4.573,0,0,1-.58-2.195,7.091,7.091,0,0,1,.382-2.917A2.6,2.6,0,0,1,10.43,6.724c-.211-.954-.773-1.582-2.269-1.582-2.4,0-2.4,1.609-2.4,3.594a3.567,3.567,0,0,0,1.6,2.968v.659c-2.709.221-4.792,1.553-4.792,3.162H6.053A5.115,5.115,0,0,1,6.654,15.067Z",
    transform: "translate(-2.571 -5.143)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.e73ac905.svg";
export { ForwardRef as ReactComponent };